// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.public',
    path: 'my/BackedApplication',
    name: 'UserBackList',
    component: () => import('./PgUserBackList'),
    meta: { // my backed project
      title: '支持项目申請',
      authenticated: true
    }
  }
]
